import { useEffect, useState } from "react";
import axios from "axios";
import { Collectible } from "./types";

/**
 * Fetches products from the existing getAllProductsFromDatabase API
 * and maps them to the Collectible interface for the new Buy&Get UI.
 */
const useBuyGetData = () => {
  const [collectibles, setCollectibles] = useState<Collectible[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_V2E}getAllProductsFromDatabase`
        );
        const products: any[] = res?.data?.data || [];
        // Map existing products to Collectible interface
        const items: Collectible[] = products
          .filter((p: any) => p.remaining > 0 || p.totalSupply > 0)
          .sort((a: any, b: any) => (a.priceUsd ?? 0) - (b.priceUsd ?? 0))
          .map((p: any) => ({
            id: String(p.id),
            slug: String(p.id),
            name: p.name ?? "",
            tier: p.rarity ?? "Common",
            cardClass: p.rarity ?? "",
            unitPrice: p.priceUsd ?? 0,
            unitVcoin: p.vCoin ?? 0,
            powerMult: 1,
            powerUses: 0,
            totalSupply: p.totalSupply ?? 0,
            remainingSupply: p.remaining ?? 0,
            supplyDays: 7,
            images: p.image_link ? [p.image_link] : [],
            isMystery: p.name === "Mystery Box" || p.name === "Gold Mystery Box",
            tag: p.name === "Mystery Box" ? "Most Popular" as const : undefined,
            isActive: true,
            productId: p.id,
          }));
        setCollectibles(items);
      } catch (err: any) {
        setError(err?.message ?? "Failed to load collectibles");
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  return { collectibles, loading, error };
};

export default useBuyGetData;
